export default __webpack_public_path__ + "static/MHV-6b52f17a7ea588c267fa7c488a1240b8.png";